import classNames from "classnames";
import s from "./index.module.css"
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet';

const Table = ({sort, setSort, state, setValue}) => {
    return (
        <div className={classNames(s.tableWrapper, 'customScroll')}>
            <table className={classNames(s.table, s.tableSize)}>
                <thead>
                    <tr>
                        <th></th>
                        <th>ID</th>
                        <th>
                            <div className={s.thWrapper}>
                                <span>Имя</span>
                            </div>
                        </th>
                        <th>
                            <div className={s.thWrapper}>
                                <span>E-mail</span> 
                            </div>
                        </th>
                        <th>
                            <div className={s.thWrapper}>
                                <span>Телефон</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    { state.map(el =>
                            <tr key={el.id}>
                                <td>
                                <CheckboxViolet
                                    text={''}
                                    value={true}
                                    setValue={()=>setValue(el.id)}
                                    blockClassName={s.checkboxBlock}
                                    textClassName={s.checkboxText1}
                                />
                                </td>
                                <td>{ el.id }</td>
                                <td><span>{ el.name }</span></td>
                                <td>{ el.email }</td>
                                <td><span>{ el.phone }</span></td>
                            </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default Table;